import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CustomLink from 'components/Common/CustomLink/CustomLink';
import ModalForgotPassword from 'components/Modals/ModalForgotPassword/ModalForgotPassword';
import { pushGtmEvent } from 'services/gtm/gtmEvents';

export type Props = {
  isCheckoutPage: boolean;
  classes: Partial<{
    wrapper: string;
    link: string;
  }>;
};

export default function ForgotPasswordLink({
  isCheckoutPage,
  classes,
}: Props): JSX.Element {
  const { t } = useTranslation(['loginPage']);
  const [openModal, setOpenModal] = useState(false);

  function onClick() {
    pushGtmEvent({
      event: '_forgot_password',
      user_login_type: isCheckoutPage ? 'checkout' : 'compte',
    });

    setOpenModal(true);
  }

  return (
    <>
      <div className={classes?.wrapper}>
        <CustomLink to="#" onClick={onClick} className={classes?.link}>
          {t('LABEL_FORGOT_PASSWORD')}
        </CustomLink>
      </div>
      {openModal && (
        <ModalForgotPassword
          isOpen={true}
          closeModal={() => setOpenModal(false)}
        />
      )}
    </>
  );
}
